import { z } from 'zod';

export const userTypeSchema = z.union([
  z.literal('restaurantUser'),
  z.literal('restaurantCustomer'),
  z.literal('superAdmin'),
]);
export type UserType = z.output<typeof userTypeSchema>;

export const cognitoUserDataSchema = z.object({
  userType: userTypeSchema,
});
export type CognitoUserData = z.output<typeof cognitoUserDataSchema>;
